import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73f7b626"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comments-container" }
const _hoisted_2 = {
  key: 1,
  class: "no-data"
}
const _hoisted_3 = {
  "data-int": "comments-no-data",
  class: "subtitle has-text-centered"
}

import CommentsEdit from './CommentsEdit.vue'
import CommentsList from "./CommentsList.vue"
import VirtualList from "vue3-virtual-scroll-list"
import UtilityBlock from "@/components/common/UtilityBlock.vue"

import { computed, onMounted, ref } from "vue"
import { useStore } from "vuex"
import { useBreakpoints } from "@/helpers/responsiveBreakpoints"


export default /*#__PURE__*/_defineComponent({
  __name: 'Comments',
  setup(__props) {

const store = useStore()
const { width } = useBreakpoints()

const editing = ref<Object>({
  acl: 'all',
  id: '',
  text: '',
  publicBelowOrg: null
})
const loading = ref<boolean>(false)
const active = ref<boolean>(false)
const comments = computed(() => store.state.content.comments.items)
const editingComment = computed(() => store.state.content.comments.editingComment)
const total = computed(() => store.state.content.comments.total)
const offset = computed(() => store.state.content.comments.offset)
const loadingComments = computed(() => store.state.content.comments.loadingComments)
const updating = computed(() => store.state.content.comments.updating)

const scroll = computed(() => {
  if(width.value > 900) {
    return `
            max-height: 340px;
            overflow-y: scroll;
            overflow-x: hidden;
          `
  } else {
    return `
            max-height: 320px;
            overflow-y: scroll;
            overflow-x: hidden;
          `
  }
})
const canAddAndEditComments = computed(() => store.getters['user/canAddAndEditComments'])
const canEditAllComments = computed(() => store.getters['user/canEditAllComments'])


const submit = async () => {
  await store.dispatch('content/saveComment', { comment: editing.value, saveOnly: true  })
  await clearState()
}
// cancel is only being used for click button event
const cancel = () => {
  editing.value = {
    id: '',
    text: '',
    acl: 'all',
    publicBelowOrg: null
  }
}
const setCommentsResultsPerPage = async () => {
  await store.dispatch('content/setCommentsResultsPerPage', 5)
}
const setBypassPagination = async () => {
  await store.dispatch('content/setBypassPagination', true)
}
const toBottom = async () => {
  if(loadingComments.value) return
  if(comments.value.length < total.value) {
    const newOffset = offset.value + 1
    await store.dispatch('content/setCommentsPage', newOffset)
  }
}
const clearState = async () => {
  await store.dispatch('content/clearComments')
  await setBypassPagination()
  await setCommentsResultsPerPage
  await store.dispatch('content/getComments')
}
onMounted(async () => {
  await setBypassPagination()
  await setCommentsResultsPerPage()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (comments.value.length && !updating.value && !loadingComments.value)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(["comments-results", {'full-height': !!editingComment.value, 'new-active': active.value}])
        }, [
          _createVNode(_unref(VirtualList), {
            "data-component": CommentsList,
            "data-sources": comments.value,
            style: _normalizeStyle(scroll.value),
            keeps: 20,
            "bottom-threshold": 300,
            "data-key": 'id',
            onTobottom: toBottom
          }, null, 8, ["data-sources", "style"])
        ], 2))
      : _createCommentVNode("", true),
    (!total.value && !updating.value  && !loadingComments.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('assetsNotFound', {type: _ctx.$tc('comment', 2)})), 1)
        ]))
      : _createCommentVNode("", true),
    (loadingComments.value || updating.value)
      ? (_openBlock(), _createBlock(UtilityBlock, { key: 2 }))
      : _createCommentVNode("", true),
    ((canAddAndEditComments.value || canEditAllComments.value) && !editingComment.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["comments-new", {'active': active.value}])
        }, [
          _createVNode(CommentsEdit, {
            comment: editing.value,
            onActive: _cache[0] || (_cache[0] = val => active.value = val),
            onSubmit: submit,
            onCancel: cancel
          }, null, 8, ["comment"])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})